import { render, staticRenderFns } from "./RoomInfo.vue?vue&type=template&id=1dd08c3a&scoped=true&"
import script from "./RoomInfo.vue?vue&type=script&lang=js&"
export * from "./RoomInfo.vue?vue&type=script&lang=js&"
import style0 from "./RoomInfo.vue?vue&type=style&index=0&id=1dd08c3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd08c3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dd08c3a')) {
      api.createRecord('1dd08c3a', component.options)
    } else {
      api.reload('1dd08c3a', component.options)
    }
    module.hot.accept("./RoomInfo.vue?vue&type=template&id=1dd08c3a&scoped=true&", function () {
      api.rerender('1dd08c3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Camstudy/RoomInfo.vue"
export default component.exports